import { makeStyles } from '@material-ui/core';
import { colors } from 'styles/colors';
import spacing from 'styles/spacing';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  actionsButtons: {
    '& > *:first-child': {
      marginRight: spacing.xsmall,
    },
  },
  addItem: {
    color: colors.primary,
  },
  description: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  questionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '16px',
  },
  orderDescriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  orderDescription: {
    marginRight: '10px',
  },
  borderButton: {
    border: `solid 1px ${colors.lightGray02}`,
    marginRight: '16px',
  },
});

export default useStyles;
